module.exports = __webpack_public_path__ + "static/media/ponyo.76cd34cb.jpg";